import { FormTypes } from '../globalDestServiceConstants';
import {
  createLanguageTrainingColumns,
  createLanguageTrainingPostRequest,
  createLanguageTrainingPutRequest,
  createLanguageTrainingRows
} from '../formData/languageTrainingFormData';
import { showToast } from 'modules/layout/layout.actions';
import { useCreateDataHandler } from '../apiHandlers/useCreateDataHandler';
import { useDeleteDataHandler } from '../apiHandlers/useDeleteDataHandler';
import { useFetchGlobalDestinationServiceDataHandler } from '../apiHandlers/useFetchDataHandler';
import { useUpdateDataHandler } from '../apiHandlers/useUpdateDataHandler';
import CrudTable from 'modules/clients/details/crudTable.component';
import React, { useRef, useState } from 'react';
import SpinnerComponent from 'modules/common/spinner.component';

const LanguageTrainingCrudTable = ({ authId, globalId, isReadOnly, languageData, vendors, vendorContacts, familyMembers, countries, allVendors }) => {
  const createDataHandler = useCreateDataHandler(showToast);
  const updateDataHandler = useUpdateDataHandler(showToast);
  const deleteDataHandler = useDeleteDataHandler(showToast);
  const dataHandler = useFetchGlobalDestinationServiceDataHandler(showToast);

  const [isLocalLoading, setIsLocalLoading] = useState(false);
  const scrollPositionRef = useRef(0);
  const containerRef = useRef(null);

  const handleCrudOperation = async (operation, ...args) => {
    scrollPositionRef.current = window.scrollY;
    setIsLocalLoading(true);
    const response = await operation(...args);
    if (response) {
      await dataHandler.fetchData(authId);
    }
    setTimeout(() => {
      window.scrollTo(0, scrollPositionRef.current);
      setIsLocalLoading(false);
    }, 0);
    return response;
  };

  const updateRow = async (originalRow, newRow) => {
    return await handleCrudOperation(
      updateDataHandler.updateData,
      FormTypes.LanguageTraining,
      authId,
      globalId,
      languageData[originalRow.index].globalLanguageTrainingServiceId,
      createLanguageTrainingPutRequest(languageData[originalRow.index], newRow, globalId)
    );
  };

  const createRow = async newRow => {
    return await handleCrudOperation(
      createDataHandler.createData,
      FormTypes.LanguageTraining,
      authId,
      globalId,
      createLanguageTrainingPostRequest(newRow, globalId)
    );
  };

  const deleteRow = async rowToDelete => {
    return await handleCrudOperation(
      deleteDataHandler.deleteData,
      FormTypes.LanguageTraining,
      authId,
      globalId,
      rowToDelete.original.globalLanguageTrainingServiceId
    );
  };

  return (
    <div style={{ minHeight: '200px', position: 'relative' }} ref={containerRef}>
      {isLocalLoading ? (
        <div style={{ position: 'absolute', display: 'flex' }}>
          <SpinnerComponent />
        </div>
      ) : (
        <CrudTable
          editingMode="modal"
          columns={createLanguageTrainingColumns(vendors, vendorContacts, familyMembers, countries, allVendors)}
          rows={createLanguageTrainingRows(languageData)}
          updateRow={updateRow}
          createRow={createRow}
          deleteRow={deleteRow}
          customAddText="Add Language Training"
          hideEdit={isReadOnly}
          toolbarCustomButton
          customButtonText="Order Service"
          customButtonMethod={() => alert('Order Service Letter Sent Successfully!')}
        />
      )}
    </div>
  );
};

export default LanguageTrainingCrudTable;
